export default {"src":"/_next/static/media/0xdf574c24545e5ffecb9a659c229253d4111d87e1.d2b1415e.svg","height":2000,"width":2000,"blurWidth":0,"blurHeight":0};